export const sv = {
    commonLabels: {
        courses: `kurser`,
        lessons: `lektioner`,
        chapters: `Kapitlen`,
        sections: `Sections`,
        course: `Kurser`,
        lesson: `Lektion`,
        chapter: `Kapitel`,
        section: `Section`,
        success: `Framgångsrikt/genomfört`,
        error: `Error`,
        action: `Åtgärd`,
        comment: `Kommentera`,
        ok: `OK`,
        confirm: `bekräfta`,
        confirmation: `Bekräftelse`,
        cancel: `avbryt`,
        submit: `Skicka`,
        create: `Skapa`,
        add: `Lägg till `,
        view: `Vy`,
        edit: `Redigera`,
        update: `Update`,
        delete: `Ta bort`,
        back: `Tillbaka`,
        continue: `Fortsätt`,
        save: `Spara`,
        upload: `Ladda upp`,
        select: `Välj`,
        enter: `Ange`,
        required: `Krävs/nödvändig`,
        name: `Namn`,
        description: `Beskrivning`,
        email: `Redigera`,
        emailId: `E-post-ID`,
        address: `Adress`,
        phone: `Tel.`,
        phoneNo: `Telefonnummer`,
        status: `Status`,
        editor: `Editor`,
        reviewer: `Reviewer`,
        owner: `Owner`,
        owners: `ägare`,
        saveAndContinue: `Spara & Fortsätt`,
        basicInformation: `Grundläggande information`,
        fundamentals: `Grundläggande principer`,
        courseOutline: `Kursplan`,
        knowledgeGoals: `Kunskapsmål`,
        targetAudience: `TMålgrupp`,
        prerequisites: `Förkunskaper`,
        trainingObjectives: `Utbildningsmål`,
        subjects: `Ämnen`,
        useCases: `Användningsområden`,
        subject: `Ämnen`,
        useCase: `Användningsfall`,
        ekcMatrix: `EKC-matris`,
        contentDescription: `Innehållsbeskrivning`,
        programPlan: `Programplan`,
        export: `Export`,
        viewData: `se data`,
        editData: `redigera data`,
        deleteData: `ta bort data`,
        noRecordsFound: `ingen data tillgänlig`,
        inactive: `Inaktiv`,
        loading: `Laddar`,
        dontKnowWhereToStart: `Vet du inte var du ska börja?`,
        overview: `Överblick`,
        team: `Team`,
        role: `roll`,
        srNo: `Sr. No`,
        file: `fil`,
        files: `filer`,
        value: `Värde`,
        moveOnCourseMsg: `You are about to save this programme's basic information and moving forward towards creating courses. In order to ensure a proper setup for the rest of this programme please makes sure that all Basic information have been filled in.`,
        enterNewVersionName: `Ange ett nytt versions namn`,
        newVersion: `Ett nytt versions`,
        pleaseEnterPrompt: `Ange instruktioner.`,
        areYouSure: `Är du säker?`,
        yes: `Ja`,
        no: `No`,
        wantToContinue: `Vill du fortsätta?`,
        duplicateFileValidation: `File with same name already exists in this program:`,
        fileLimit: `You can upload a maximum of 25 files in each program`,
        invalidFile: `Ogiltigt format`,
        versionError: `Versionsnamnet får inte vara tomt.`,
        versionUnique: `Versionens namn måste vara unikt.`,
        addLesson: `Lägg till Lektion`,
        editCourse: `Redigera Kurser`,
        deleteCourse: `Ta bort Kurser`,
        addChapter: `Lägg till Kapitel`,
        editChapter: `Redigera Kapitel`,
        deleteChapter: `Ta bort Kapitel`,
        editLesson: `Redigera Lektion`,
        deleteLesson: `Ta bort Lektion`,
        addSection: `Lägg till sektion`,
        editSection: `Redigera sektion`,
        deleteSection: `Ta bort sektion`,
        productionDashboard: `Produktions kontrolpanel`,
        draftVersionConfirmationMsg: `There is a draft version data available for this. Press 'Yes' to use the saved draft data or 'No' to proceed with the existing/blank data.`,
        maxLengthReached: `Maximal längd uppnådd`,
        maxLimitReached: `Maximal gräns nådd`,
        sessionExpire: `Your session has expired, Please login again.The system has not saved your unsaved data. Kindly re-login to continue your work.`,
        sessioTitle: `Session Timeout`,
        reLogin: `Re-Login`,
        storyboard: `Storyboard`,
        deleteFileConfirmation: `Är du säker att du vill ta bort filen?`,
        invalidFormat: `Ogiltigt format`,
        closeVersion: `Close Version`,
        confirmDelete: `Bekräfta radering`,
        selectCourses: `välj kurser`,
        includeResource: `Do not include resources`,
        selectCourse: `Please Select Courses`,
        selected: `selected`,
        use: 'Använd',
        assist: `assistenten`,
        sectionTitle: `Rubriken för avsnittet`,
        script: `Manus`,
        resources: `Resurser`,
        notes: `Regi`,
        presentation: `Presentation`,
    },
    otpLabels: {
        enterOtp: `ange ditt engångslösenord.`,
        didntReceiveOtp: `har du inte mottagigt något engångslösenord?`,
        clickToResend: `klicka för att skicka igen`,
    },
    roleSelectionLabels: {
        selectRole: `välj roll`,
        logOut: `logga ut`,
    },
    homePageLabels: {
        home: `Hem`,
        homePageDescription: `Här kan du se alla program som du är en del av. Du kan sortera efter önskemål eller skapa ett nytt program.`,
        homeReviewerView: `Here you can see all the Programmes you are a part of.`,
        createProgramme: `Skapa program`,
        searchInputPlaceholder: `Programnamn, Kursnamn eller Ägarnamn`,
        selectDateRange: `Välj Datumintervall`,
        sortBy: `Sortera efter`,
        lastVisited: `Bekräfta`,
        sortByAtoZ: `Sortera efter A-Z`,
        sortByZtoA: `Sortera efter Z-A`,
        sortByNewestFirst: `Sortera efter Nyaste först`,
        sortByOldestFirst: `Sortera efter äldst först`,
        newestFirst: `Sortera efter Nyaste först`,
        viewInTop: `Visa i toppen`,
        deleteProgramConfirmationMsg1: `Är du säker på att du vill ta bort det här programmet`,
        deleteProgramConfirmationMsg2: `Denna åtgärd kommer att arkivera programmet och det kommer inte längre att vara synligt i programkatalogen. Du kan inte återställa det senare om det behövs`,
        noResultsFound: `inget resultat`,
        createdOn: `Skapad den`,
        configureProgram: `modifiera programmet`,
        productionDashboard: `Produktions kontrolpanel`,
        draftVersionMessage: `You have saved draft data available.`,
        downloadFile: `Download file`,
        noCourseAssigned: `No Course assigned, please contact admin.`,
    },
    topBarLabels: {
        home: `Hem`,
        overview: `Överblick`,
        productionDashboard: `Produktions kontrolpanel`,
        team: `Team`,
        members: `medlem`,
        knowledgeBank: `Kunskapsbank`,
        accountType: `konto typ`,
        myProfile: `min profil`,
        logout: `logga ut`,
        role: `Roll`,
    },
    teamLabels: {
        listOfTeams: `Team-lista`,
        addTeam: `lägg till team`,
        searchInputPlaceholder: `team namn eller besskrivning`,
        teamName: `Team namn`,
        teamDescription: `Team beskrivning`,
        numberOfMember: `antal medlämmar`,
        assignedCourse: `Tilldelad kurs`,
        teamNameIsRequired: `Team namn är obligatoriskt`,
        selectTeamMember: `välj team medlem`,
        assignMember: `tilldela medlem`,
        assignRole: `tilldela roll`,
        selectMember: `välj medlem`,
        selectRole: `välj roll`,
        enterTeamDescription: `lägg till team-beskrivning`,
        assignTeam: `tilldela team`,
        selectCourse: `välj kurs`,
        deleteTeamConfirmationMsg: `är du säker på att du vill ta bort detta Team`,
        invalidFormError: `Both user and roles are necessary!`,
        enterTeamName: `ange team namn`,
        teamMember: `Team medlem`,
        assignCourse: `Tilldela kurs`,
    },
    membersLabels: {
        importMembers: `Importera medlemmar`,
        addMembers: `Lägg till medlem`,
        editMembers: `Redigera användare`,
        listOfMembers: `medlemmslista`,
        searchInputPlaceholder: `Namn, e-post-ID eller telefonnummer`,
        userId: `Användar ID`,
        organizationName: `organisations namn`,
        organizationRole: `roll i organisation`,
        systemRole: `Systemroll`,
        resetPassword: `Återställ lösenord`,
        selectFile: `Välj fil`,
        chooseFile: `Välj fil`,
        noFileChosen: `Ingen fil vald`,
        downloadSampleFile: `Hämta provfil`,
        fileSelectionError: `Ingen fil vald. Vänligen välj en giltig Excel- eller CSV-fil`,
        confirmMessage: `Bekräfta meddelande`,
        userDeactivateConfirmationMsg: `Om du fortsätter med att avaktivera den här användarens status, observera att de kommer att tas bort permanent från alla team. Denna åtgärd kan inte ångras.`,
        selectSystemRole: `välj systemroll`,
        systemRoleIsRequired: `systemroll är obligatorisk`,
        sendPassword: `skicka lösenord`,
        sendPasswordConfirmMsg: `Är du säker på att du vill skicka lösenordet?`,
        send: `Skicka`,
        deleteMemberConfirmationMsg: `Är du säker på att du vill ta bort den här medlemmen`,
        importMembersErrorMsg: `Some members could not be imported. Please review and correct the Excel data, then retry.`,
        noneImportMembersErrorMsg: `None members were imported. Please review and correct the Excel data, then retry.`,
        maximumFileSize: `Maximum file size: 50 MB`,
        confirmContinue: `Är du säker på att du vill fortsätta?`,
        fileSizeError: `File size exceeds 50 MB. Please upload a smaller file.`,
        fileInvalidError: `Invalid file format. Please upload an Excel or CSV file.`,
        zeroimportData: `None members were imported.`,
        downloadFile: `Download file`,
    },
    profileLabels: {
        profile: `Profil`,
        changePassword: `Ändra lösenord`,
        userId: `Användar-ID`,
        organization: `Organisation namn`,
        organizationRole: `Organisationsroll`,
        enterName: `Ange namn`,
        enterEmail: `Ange email`,
        enterOrganization: `Ange organisation`,
        enterOrganizationRole: `ange Organisationsroll`,
        enterAddress: `Ange adress`,
        nameIsRequired: `Ett namn är obligatoriskt`,
        phoneIsRequired: `Ett Telefonnummer är obligatoriskt`,
        userSavedImageNotSaved: `User saved successfully, Image not uploaded!`,
    },
    changePasswordLabels: {
        currentPassword: `Nuvarande lösenord`,
        currentPasswordIsRequired: `Nuvarande lösenord krävs`,
        enterCurrentPassword: `Ange nuvarande lösenord`,
        newPassword: `Nytt lösenord`,
        passwordIsRequired: `Lösenord krävs`,
        enterNewPassword: `Ange nytt lösenord`,
        confirmNewPassword: `Bekräfta nytt lösenord`,
        enterConfirmNewPassword: `Ange Bekräfta nytt lösenord`,
        passwordUpercaseError: `Lösenordet måste innehålla minst en versal bokstav.`,
        passwordLowercaseError: `Lösenordet måste innehålla minst en gemener bokstav.`,
        confirmPasswordIsRequired: `Lösenordet behövs bekräftas`,
        passwordNotMatchError: `Det bekräftade lösenordet stämmer inte överens med det nya lösenordet`,
        passwordRequirements: `Krav på lösenord`,
        atLeast8charactersLong: `Minst 8 tecken långt`,
        atLeast1Uppercase: `Måste innehålla en stor bokstav (A-Z)`,
        atLeast1Lowercase: `Måste innehålla en liten bokstav (a-z)`,
        atLeast1Number: `Måste innehålla minst en siffra (0-9)`,
        atLeast1SpecialCharacter: `Måste innehålla ett specialtecken (! @ # $ % ^ & * ( ))`,
    },
    forgotPasswordLabels: {
        forgotYourPassword: `glömt ditt lösenord?`,
        emailAddress: `emailadress`,
        enterEmailAddress: `ange emailadress`,
        emailIsRequired: `email behövs`,
    },
    createProgramLabels: {
        createNewProgram: `Skapa nytt program`,
        allowOnlyFiles: `tillåt endast .jpg- eller .png-fil`,
        nameOfProgram: `Programnamn`,
        enterProgramName: `Ange programnamnet`,
        nameIsRequired: `Namn är obligatoriskt`,
        programDescription: `Beskrivning av programmet`,
        showOnCatelogueCards: `Denna text visas endast på katalogkorten`,
        uploadCoverPhoto: `Ladda upp omslagsbild`,
        addOwners: `Lägg till ägare`,
        dragFile: `Dra en fil eller`,
        clickSelect: `klicka på välj`,
        fileSelectionPlaceholder: `för att ladda upp filer du vill använda under skapandet av ditt program.`,
        editProgram: `Edit Programme`,
        fileSizeLimit20MB: `exceeds the 50 MB size limit.`,
        fileAlreadyUploaded: `is already uploaded.`,
        ownerRequiredMsg: `At least one owner is required.`,
        fileSizeLimit5MB: `Cover photo exceeds the 50 MB size limit.`,
        coverPhoto: `Upp omslagsbild`,
        selectOwner: `Välj ägare`,
        allowOnly: `tillåt only`,
        deleteImgConfirmation: `Är du säker att du vill radera Bild?`,
        allowFiles: `files.`,
        allowUpto: `Can upload maximum of 25 files. Each file size limits 50MB size.`,
        fileLimit: `You can upload a maximum of 25 files.`,
        uploadFailed: `Files not uploaded`,
        descriptionHint: `Maximalt 4 000 tecken. Innehåll som överskrider denna gräns kan komma att kortas ned.`,
        loading: `laddar...`,
    },
    configureProgramLabels: {
        knowledgeGoalsPara1: `Kunskapsmålen definierar de väsentliga kunskaper, färdigheter och kompetenser som en elev ska förvärva efter att ha slutfört programmet. Dessa mål säkerställer att alla kurser inom programmet bidrar till ett väl avrundat läranderesultat.`,
        knowledgeGoalsPara2: `Eftersom ett program består av flera kurser är det viktigt att fastställa kunskapsmål som omfattar hela läroplanen. Detta bidrar till att upprätthålla konsekvens och säkerställer att eleverna uppnår den avsedda kompetensen.`,
        targetAudiencePara1: `Med <b>målgrupp</b> målgrupp avses den specifika grupp av elever som ett eLearning-program är utformat för. Att identifiera målgruppen hjälper till att säkerställa att kursens innehåll, språk och struktur är lämpliga för deras behov, förkunskaper och inlärningsmål.`,
        targetAudiencePara2: ``,
        prerequisitePara1: `Förkunskaper avser de grundläggande färdigheter, begrepp eller erfarenheter som eleverna bör ha innan de påbörjar en kurs eller ett program. Genom att fastställa förkunskaper säkerställer man att deltagarna effektivt kan ta till sig materialet utan onödig förvirring eller luckor i förståelsen.`,
        prerequisitePara2: ``,
        trainingObjectivesPara1: `Utbildningsmålen definierar de specifika färdigheter, kunskaper eller kompetenser som deltagarna ska förvärva i slutet av en kurs eller ett utbildningsprogram. De fungerar som tydliga, mätbara mål som styr både undervisningsdesign och elevens framsteg, vilket säkerställer att utbildningen är fokuserad och resultatdriven.`,
        trainingObjectivesPara2: `Det kommer att bidra till att utforma utvärderingar som exakt mäter inlärningsresultat och ger eleverna en tydlig väg till att förvärva och tillämpa ny kunskap. Medan kunskapsmålen definierar vad deltagarna i slutändan ska veta, anger utbildningsmålen hur de ska nå dit, vilket säkerställer en strukturerad och effektiv inlärningsupplevelse.`,
        useCasesPara1: `Det kommer att bidra till att utforma utvärderingar som exakt mäter inlärningsresultat och ger eleverna en tydlig väg till att förvärva och tillämpa ny kunskap. Medan kunskapsmålen definierar vad deltagarna i slutändan ska veta, anger utbildningsmålen hur de ska nå dit, vilket säkerställer en strukturerad och effektiv inlärningsupplevelse.`,
        useCasesPara2: `Användningsfall beskriver de verkliga tillämpningar eller scenarier där kursinnehållet kommer att tillämpas. De hjälper till att skräddarsy material, exempel och aktiviteter för att matcha elevernas arbetsmiljöer, branscher eller specifika inlärningsbehov.`,
        ekcMatrixPara1: `EKC-matrisen är ett strukturerat ramverk som organiserar ämnen och användningsfall i en tabell, vilket gör det möjligt för kursskapare att definiera den inlärningsnivå som krävs vid varje korsning. Genom att kategorisera inlärningsmål i olika nivåer säkerställer EKC-matrisen en tydlig progression av kunskaps- och färdighetsutveckling genom en kurs eller ett program.`,
        ekcMatrixPara2: `Matrisen består av tre inlärningsnivåer: <br> <b>Nivå 1 –  Förstå:</b>  Eleverna ska få grundläggande kunskaper som gör att de kan förstå ämnet i ett specifikt användningsfall. Denna nivå fokuserar på medvetenhet och konceptuell förståelse. <br> <b>Nivå 2 – Tillämpa:</b>  Eleverna ska kunna använda den förvärvade kunskapen för att lösa problem eller utföra uppgifter som är relaterade till ämnet i ett specifikt användningsfall. Denna nivå betonar praktisk tillämpning.<br> <b>Nivå 3 – Skapa:</b> Deltagarna ska kunna generera nya idéer, lösningar eller innehåll baserat på den kunskap som erhållits under kursen. Denna nivå fokuserar på innovation och behärskning.`,
        contentDescriptionPara1: `Innehållsbeskrivningen beskriver de specifika material, ämnen och lärresurser som ingår i en kurs eller ett utbildningsprogram. Den ger en översikt över vad deltagarna kommer att engagera sig i och säkerställer att kursstrukturen är tydlig, organiserad och anpassad till lärandemålen.`,
        contentDescriptionPara2: `Tänk på detta som ditt fria flöde av idéer för kursen. Det är här du kartlägger allt du vill ta upp, från nyckelbegrepp och instruktionsmaterial till interaktiva element och utvärderingar. Det är ditt kreativa utrymme för brainstorming om hur du bäst kan presentera ämnet.`,
        assistCourseInitiatePara1: `Baserat på din input på de tidigare sidorna kan vi nu skapa din kursplan.`,
        assistCourseInitiatePara2: `Du kan antingen fylla i dem en efter en eller be Eduscript-assistenten om hjälp.`,
        assistCourseConfirmationPara1: `Hej, vill du ha hjälp att skapa en kursplan?`,
        assistCoursePromptPara1: `Bra! Baserat på den information du har angett kommer jag att ge dig ett förslag på en kursplan.`,
        assistEditCourseInitiatePara1: `Baserat på din input på de tidigare sidorna kan vi nu skapa dina kursdata.`,
        assistEditCourseInitiatePara2: `Du kan antingen fylla i dem en efter en eller be Eduscript-assistenten om hjälp.`,
        assistEditCourseConfirmationPara1: `Hej, vill du ha hjälp att skapa data?`,
        assistEditCoursePromptPara1: `Bra! Baserat på den information du har gett kommer jag att ge dig ett förslag på kursdata.`,
        assistLessonInitiatePara1: `Baserat på din input på de tidigare sidorna kan vi nu skapa din lektionsplan.`,
        assistLessonInitiatePara2: `Du kan antingen fylla i dem en efter en eller be Eduscript-assistenten om hjälp.`,
        assistLessonConfirmationPara1: `Hej, vill du ha hjälp att skapa en lektionsplan?`,
        assistLessonPromptPara1: `Bra! Baserat på den information du har gett kommer jag att ge dig ett förslag på en lektionsplan.`,
        assistEditLessonInitiatePara1: `Baserat på din input på de tidigare sidorna kan vi nu skapa dina lektionsdata.`,
        assistEditLessonInitiatePara2: `Du kan antingen fylla i dem en efter en eller be Eduscript-assistenten om hjälp.`,
        assistEditLessonConfirmationPara1: `Hej, vill du ha hjälp att skapa data?`,
        assistEditLessonPromptPara1: `Bra! Baserat på den information du har gett kommer jag att ge dig ett förslag på lektionsdata.`,
        assistChapterInitiatePara1: `Baserat på din input på de tidigare sidorna kan vi nu skapa dina kapitel`,
        assistChapterInitiatePara2: `Du kan antingen fylla i dem en efter en eller be Eduscript-assistenten om hjälp.`,
        assistChapterConfirmationPara1: `Hej, vill du ha hjälp att skapa kapitel`,
        assistChapterPromptPara1: `Bra! Baserat på den information du har gett kommer jag att ge dig ett förslag på kapitel.`,
        assistEditChapterInitiatePara1: `Baserat på din input på de tidigare sidorna kan vi nu skapa kapiteldata.`,
        assistEditChapterInitiatePara2: `Du kan antingen fylla i dem en efter en eller be Eduscript-assistenten om hjälp.`,
        assistEditChapterConfirmationPara1: `Hej, vill du ha hjälp att skapa data?`,
        assistEditChapterPromptPara1: `Bra! Baserat på den information du har gett kommer jag att ge dig ett förslag på kapiteldata.`,
        assistSectionInitiatePara1: `Baserat på din input på de tidigare sidorna kan vi nu skapa dina kapitel`,
        assistSectionInitiatePara2: `Du kan antingen fylla i dem en efter en eller be Eduscript-assistenten om hjälp.`,
        assistSectionConfirmationPara1: `Hej, vill du ha hjälp att skapa kapitel`,
        assistSectionPromptPara1: `Bra! Baserat på den information du har gett kommer jag att ge dig ett förslag på kapitel.`,
        assistEditSectionInitiatePara1: `Baserat på dina uppgifter på de föregående sidorna kan vi nu skapa dina skriptdata.`,
        assistEditSectionInitiatePara2: `Du kan antingen fylla i dem en efter en eller be Eduscript-assistenten om hjälp.`,
        assistEditSectionConfirmationPara1: `Hej, vill du ha hjälp att skapa data?`,
        assistEditSectionPromptPara1: `Bra! Baserat på den information du har gett kommer jag att ge dig ett förslag på kapiteldata.`,
        updateAiCourseConfirmation: `Detta kommer att ersätta din nuvarande plan {{versionName}} med Data genererat av AI`,
        updateAiLessonConfirmation: `Detta kommer att ersätta dina nuvarande Lektioner {{versionName}} med Data genererat av AI`,
        updateAiChapterConfirmation: `Detta kommer att ersätta dina nuvarande kapitel i {{versionName}} med Data genererat av AI`,
        updateAiSectionConfirmation: `Detta kommer att ersätta dina nuvarande sektioner i {{versionName}} med Data genererat av AI`,
        addAiCourseConfirmation: `Detta kommer att lägga till de Ai genererade Kurserna till  {{versionName}}.`,
        addAiLessonConfirmation: `Detta kommer att lägga till de Ai genererade lektioner till  {{versionName}}.`,
        addAiChapterConfirmation: `Detta kommer att lägga till de Ai genererade kapitel till  {{versionName}}. `,
        addAiSectionConfirmation: `Detta kommer att lägga till de Ai genererade sektioner till {{versionName}}. `,
        dontKnow: `Vet du inte`,
        whereToStart: ` var du ska börja?`,
        eduscriptAssist: `Eduscript-assistent`,
    },
    knowledgeBankLabels: {
        searchInputPlaceholder: `Sök efter namn, typ, uppladdare`,
        createdBetween: `Skapad mellan`,
        groupBy: `Gruppera efter`,
        program: `Program`,
        documentType: `Dokumenttyp`,
        creator: `Skapare`,
        uploadFile: `Ladda upp fil`,
        totalFilesInAllProgram: `Totalt antal filer i alla program`,
        maxFileLimit: `File size should be less than 50MB`,
        size: `Storlek`,
        name: `Namn`,
        mediaType: `Mediatyp`,
        createdBy: `Skapad av`,
        uploadedAt: `Uppladdad vid`,
        action: `Åtgärd`,
        replaceData: `RErsätt data`,
        downloadData: `Ladda ner data`,
        selectProgram: `Välj program`,
        browseAndUploadFile: `Bläddra och ladda upp fil`,
        chooseFile: `Välj fil`,
        noFileChosen: `Ingen fil vald`,
        fileCaptured: `Fil mottagen`,
        deleteMediaConfirmationMsg: `Are you sure want to Delete this Media`,
        upload: `Uppladda`,
        cancel: `Avbryt`,
        loading: `Laddar...`,
        selectDateRange: `Välj datumintervall`,
        fileLimit: `You can upload a maximum of 25 files in each program.`,
    },
    overviewLabels: {
        viewProgram: `View Summary Program`,
        program: `Program`,
        selectProgram: `Välj program`,
        noResultFound: `Inget resultat hittades`,
        addCourse: `Lägg till kurs`,
        exportProgram: `Exportera`,
        fundamental: `Grundläggande`,
        comment: `Kommentera`,
        loading: `laddar...`,
        noCourseAvailable: `No Course Available`,
        pleaseSelectProgram: `Please select Programme`,
        courseDeleteConfirmation1: `Are you sure you want to remove this course`,
        courseDeleteConfirmation2: `This action will permanently delete the course and all associated Lessons, Chapters, and Sections. This action cannot be undone.`,
        lessonDeleteConfirmation1: `Are you sure you want to remove this lesson`,
        lessonDeleteConfirmation2: `This action will permanently delete the lesson and all associated Chapters and Sections. This action cannot be undone.`,
        chapterDeleteConfirmation1: `Are you sure you want to remove this chapter`,
        chapterDeleteConfirmation2: `This action will permanently delete the chapter and all associated Sections. This action cannot be undone.`,
        sectionDeleteConfirmation1: `Are you sure you want to remove this section`,
        sectionDeleteConfirmation2: `This action will permanently delete the Sections. This action cannot be undone.`,
        chapterValidation: `Kapitlet har inte flyttats till ett annat kapitel`,
        sectionValidation: `Avsnittet har inte flyttats till ett annat avsnitt`,
        withinCourseValidation: `Omplacering är endast tillåten inom samma kurs.`,
        informationShow: `Omplacering är endast tillåten inom samma kurs. Avsnitt kan flyttas mellan kapitel och kapitel kan flyttas mellan lektioner. Objekt kan dock inte byta nivå - avsnitt kan inte bli kapitel och kapitel kan inte bli lektioner.`,
        withinChapterValidation: `Section not moved to another lesson`,
        sectionwithChapterValidation: `Section not moved to another chapter`,
        noSectionFound: `Ingen sektion hittades!`,
        noPermissionToAddComment: `There are no comments present in the section and you don't have permission to add any comment.`,
    },
    ekcMatrixLabels: {
        addSubjects: `Lägg till ämnen`,
        addUsecases: `Lägg till användningsfall`,
        usecaseError: `Minst ett ämne och ett användningsfall krävs om något läggs till!`,
        understand: `Förstå`,
        apply: `Tillämpa`,
        editUsecases: `Redigera användningsfall`,
        noData: `Ingen data`,
        noDataMsg: `Vänligen skapa ämnen och use cases för att fortsätta`,
    },
    courseLabels: {
        courseOutline: `Kursplan`,
        courseTitle: `kurstitel`,
        enterCourseTitle: `Ange kurstitel`,
        courseDescription: `kursbeskrivning`,
        enterCourseDescription: `Ange kursbeskrivning`,
        manageTeamAndMembers: `Hantera team och medlemmar`,
        assignTeamAndMembers: `Tilldela team och medlem`,
        assignTeams: `Tilldela team`,
        assignedTeams: `Tilldela team`,
        assignedMembers: `Tilldela medlem`,
        selectMemberAndRole: `Välj medlem och roll`,
        memberName: `Medlemsnamn`,
        selectTeam: `Välj team`,
        courseTitleRequired: `Kurstitel är obligatorisk.`,
        courseDescriptionLimitError: `Kursbeskrivningen får vara högst 4000 tecken.`,
        wantToContinue: `Vill du fortsätta?`,
        continueConfirmation: `Du är på väg att spara programmets grundläggande information och gå vidare med att skapa kurser. För att säkerställa en korrekt inställning för resten av detta program, se till att all grundläggande information har fyllts i.`,
        newCourse: `Ny kurs`,
        removeCourse: `Ta bort kurs`,
    },
    lessonLabels: {
        lessonTitle: `lektionsrubrik`,
        enterLessonTitle: `Ange lektionsrubrik`,
        lessonDescription: `lektionsbeskrivning`,
        enterLessonDescription: `Ange lektionsbeskrivning`,
        newLesson: `Ny lektion`,
        removeLesson: `Ta bort lektion`,
    },
    chapterLabels: {
        chapterTitle: `kapiteltitel`,
        enterChapterTitle: `Ange kapiteltitel`,
        chapterDescription: `kapitelbeskrivning`,
        enterChapterDescription: `Ange kapitelbeskrivning`,
        newChapter: `Nytt kapitel`,
        removeChapter: `Ta bort kapitel`,
    },
    sectionLabels: {
        sectionTitle: `Rubriken för avsnittet`,
        enterSectionTitle: `Ange rubrik för avsnittet`,
        sectionDescription: `Avsnitt Storyboard`,
        enterSectionDescription: `Ange avsnitt Storyboard`,
        newSection: `Nytt avsnit`,
        removeSection: `Ta bort avsnitt`,
        deleteMessage: `Är du säker på att du vill ta bort det här avsnittet? Denna åtgärd kan inte ångras.`,
        scriptPlaceholder: `Skriv eller klistra in ditt manus här...`,
        scriptWriting: `Manusförfattande`,
        scriptSegmenting: `Segmentering av skript`,
        allowOnly: `Tillåt  only`,
        allowUpto: `Du kan ladda upp högst 25 filer. Varje filstorlek begränsar 50 MB storlek.`,
        fileLimit: `Du kan ladda upp maximalt 25 filer.`,
        mediaUpload: `Uppladdning av mediafiler`,
        fileAlreadyUploaded: `är redan uppladdad.`,
        deleteSectionConfirmationMessage: `Är du säker på att du vill ta bort det här segmentet?`,
        sectionScript: `Skript för avsnittet`,
        downloadData: `Ladda ner data`,
        scriptAiAssistInitiatePara1: `Baserat på dina uppgifter på de föregående sidorna kan vi nu skapa dina skriptdata.`,
        scriptAiAssistInitiatePara2: `Du kan be Eduscript assist att hjälpa dig.`,
        scriptAiAssistConfirmationPara1: `Hej, vill du ha hjälp med att skapa data?`,
        scriptAiAssistPromptPara1: `Jättebra! Baserat på den information du har lämnat kommer jag att ge dig ett förslag på en skriptdata.`,
        assist: `Eduscript-assistent`,
        uploadMedia: `Uppladdning av mediafiler`,
        typehere: `Type Note here...`,
        fileSizeLimit20MB: `Cover photo exceeds the 50 MB size limit.`,
        uploadFailed: `är redan uppladdad.`,
        dragFile: `Dra en fil eller`,
        clickSelect: `klicka på välj`,
        fileSelectionPlaceholder: `för att ladda upp filer du vill använda under skapandet av ditt program.`,
        allowFiles: `files.`,
        updateScriptConfirmationMessage: `Are you sure you want to update the script of "{{sectionName}}" section?`,
        deleteData: `Delete Data`,
        removeData: `Remove Data`,
        fileSizeLimit: `File exceeds the 50 MB size limit.`,
    },
    roleLabels: {
        listOfRoles: `List of Roles`,
        addNew: `Add New`,
        searchInputPlaceholder: `Role name or description`,
        roleName: `Role Name`,
        updateDate: `Update Date`,
        deleteRoleConfirmation: `Are you sure you want to delete this role?`,
        deactivateRoleConfirmation: `If you want to deactivate the status of this role, please ensure that all users assigned to this role are reassigned to a different role first. Users must not be left without a role before deactivation.`,
    },
    productionDashboardLabels: {
        program: `Program`,
        selectProgram: `Välj program`,
        cancel: `Avbryt`,
        selectCourses: `välj kurser`,
        selectLessons: `välj lektioner`,
        selectChapters: `välj Kapitlen`,
        selectSections: `välj Sections`,
        section: `Section`,
        filterPresentations: `Presentationer av filter`,
        exportAsExcel: `Exportera som excel`,
        applyFilters: `Tillämpa filter`,
        scriptOrSequenceOfEvent: `Manus/Händelseförlopp`,
        presentations: `Presentationer`,
        presentation: `Presentation`,
        resourcesCount: `Antal resurser`,
        directionalNotes: `Riktningsanvisningar`,
        resources: `Resurser`,
        productionMoments: `Produktions moment`,
        clearFilters: `Nollställ filter`,
        noData: `Ingen data tillgänglig`,
        loading: `Laddar...`,
        atLeastOneSectionRequired: `Minst ett avsnitt krävs för att tillämpa filter!`,
        pieChartTitle: `Presentation Type of Distribution`,
    },
    commentLabels: {
        comments: `Kommentar`,
        sectionName: `Sektionens namn`,
        sectionHeadline: `Section Headline`,
        viewLess: `Visa mindre`,
        viewMore: `Visa mer`,
        noCommentsAvailable: `Inga kommentarer tillgängliga`,
        selectSection: `Välj avsnitt`,
        pleaseSelectSection: `Vänligen välj avsnitt`,
        pending: 'Väntande',
        approved: 'Godkänd',
        rejected: 'Avvisad',
        by: 'av',
        deleteCommentConfirmation: `Är du säker på att du vill radera den här kommentaren?`,
        acceptCommentConfirmation: `Är du säker på att du vill acceptera den här kommentaren?`,
        rejectCommentConfirmation: `Är du säker på att du vill ignorera den här kommentaren?`,
        discardCommentConfirmation: `Är du säker på att du vill radera den här kommentaren?`,
    },
    createCourseLabels: {
        title: `Skapa din kurs`,
        subtitle: `Beskriv vad du vill skapa och ladda sedan upp ditt källmaterial. EduScript genererar hela strukturen.`,
        courseTitleLabel: `Kurstitel`,
        courseTitlePlaceholder: `Ge din kurs ett namn...`,
        courseTitleHint: `Valfritt — vi föreslår en titel från din beskrivning om du lämnar detta tomt.`,
        whatToCreate: `Vad vill du skapa?`,
        descriptionHelp: `Ge AI:n ett tydligt uppdrag — beskriv ämne, målgrupp och mål. Ju mer detaljer du ger, desto bättre matchar den genererade kursen din vision.`,
        descriptionHint: `Maximalt 4000 tecken. Innehåll över denna gräns kan trunkeras av AI:n.`,
        contentType: `Innehållstyp`,
        createFromDocument: `Skapa från dokument`,
        sopToElearning: `SOP till eLearning`,
        trainingCourse: `Utbildningskurs`,
        instructionalVideo: `Instruktionsvideo`,
        productMarketing: `Produktutbildning`,
        language: `Utdataspråk`,
        english: `Engelska`,
        swedish: `Svenska`,
        knowledgeLevel: `Kunskapsnivå`,
        knowledgeLevelHelp: `Styr ordval, tempo, djup och interaktivitet`,
        beginner: `Nybörjare`,
        beginnerDesc: `Inga förkunskaper krävs`,
        intermediate: `Mellannivå`,
        intermediateDesc: `Bekant med grunderna`,
        advanced: `Avancerad`,
        advancedDesc: `Djup domänerfarenhet`,
        microCourse: `Mikrokurs`,
        microCourseHelp: `Generera kortare, fokuserat innehåll med färre moduler`,
        addQuiz: `Lägg till quiz`,
        addQuizHelp: `Generera quiz och övningar från ditt källmaterial`,
        thumbnail: `Kursbild`,
        uploadImage: `Ladda upp bild`,
        aiGenerate: `AI-generera`,
        aiGenerateImage: `AI-generera bild`,
        aiGeneratingImage: `Genererar bild...`,
        aiImageGenerated: `Bilden har genererats`,
        aiImageGenerationFailed: `Misslyckades att generera bild`,
        aiImageModalTitle: `AI-genererad kursbild`,
        selectImage: `Välj`,
        regenerateImage: `Generera om`,
        provideDescriptionFirst: `Ange en kursbeskrivning först (minst 40 tecken)`,
        generatingPleaseWait: `Genererar, vänta...`,
        sourceMaterial: `Källmaterial`,
        sourceMaterialHelp: `Valfritt — ladda upp referensmaterial som EduScript kan använda som kontext när kursen genereras.`,
        describeFirst: `Beskriv först`,
        supportedFormats: `Format: PDF, DOCX, PPTX, XLSX, TXT`,
        fileLimits: `Max 50 MB per fil, upp till 25 filer`,
        generateCourse: `Generera kurs`,
        generating: `Genererar...`,
        charMinimum: `{{count}} / 40 tecken minimum`,
        locked: `Låst`,
        whatHappensNext: `Vad händer sen`,
        aiWillGenerate: `EduScript kommer att generera:`,
        willGenerateStructure: `Kursstruktur med moduler och sektioner`,
        willGenerateScripts: `Manus och storyboards för varje sektion`,
        willGenerateChecks: `Kunskapskontroller och repetitionsmoment`,
        willGenerateLevel: `Nivåanpassat ordval och tempo`,
        canEditAfter: `Du kan redigera, omorganisera och omgenerera allt i nästa steg.`,
        generatingCourse: `Genererar din kurs`,
        generatingMessage: `AI analyserar din beskrivning och skapar kursförslag...`,
        generationHint: `Detta kan ta en stund. Stäng inte den här fliken.`,
    },
    customizeCourseLabels: {
        title: `Forma din kurs`,
        subtitle: `Här är lektionerna som EduScript genererade för din kurs. Redigera, lägg till eller ta bort lektioner — förfina sedan med AI vid behov.`,
        yourBrief: `Din beskrivning`,
        courseOutline: `Lektionsöversikt`,
        courseNamePlaceholder: `Lektionsnamn`,
        courseDescPlaceholder: `Vad lektionen handlar om`,
        done: `Klar`,
        addCourse: `Lägg till en lektion`,
        refineTitle: `Förfina med AI`,
        refineHelp: `Beskriv vad du vill ändra. Till exempel: "Lägg till en lektion om säkerhet" eller "Gör beskrivningarna kortare".`,
        refinePlaceholder: `Berätta för EduScript vad som ska justeras...`,
        refineButton: `Förfina`,
        back: `Tillbaka`,
        continue: `Fortsätt`,
        saving: `Sparar…`,
        generationTitle: `Bygger ditt manus`,
        generationHint: `Detta kan ta ett par minuter. Stäng inte fliken.`,
        genPreparing: `Förbereder generering…`,
        genLessons: `Genererar lektioner för kurs`,
        genChapters: `Genererar kapitel för lektion`,
        genSections: `Genererar avsnitt för kapitel`,
        genDone: `Manuset är klart.`,
        genOf: `av`,
    },
    manuscriptLabels: {
        stepName: `Manus`,
        title: `Läs igenom din kurs`,
        subtitle: `Läs igenom hela manuset som en bok. Redigera valfritt avsnitt direkt eller be AI att förfina det. När du har granskat allt godkänner du manuset för produktion.`,
        tableOfContents: `Innehåll`,
        lessonsLabel: `lektioner`,
        lessonLabel: `Lektion`,
        storyboardNote: `Storyboard`,
        endOfManuscript: `Slut på manuset`,
        back: `Tillbaka till Anpassa`,
        approve: `Godkänn manus`,
        approveSubtext: `Skriv under och gå vidare till produktion`,
        reviewed: `granskade`,
        markReviewed: `Markera som granskad`,
        allReviewed: `Alla avsnitt granskade`,
        sectionsRemaining: `avsnitt kvar att granska`,
        learningOutcome: `Lärandemål`,
        teachingApproach: `Pedagogisk metod`,
        clickToEdit: `Klicka för att redigera`,
        clickToEditHeadline: `Klicka för att redigera rubriken`,
        clickToEditScript: `Klicka för att redigera manuset`,
        clickToEditStoryboard: `Klicka för att redigera storyboarden`,
        editHint: `Tryck Esc för att avbryta`,
        doneEditing: `Klar`,
        suggestWithAi: `Förfina avsnittet med AI`,
        refineWithAi: `Förfina avsnittet med AI`,
        refineHelp: `Beskriv hur du vill ändra avsnittet. Till exempel: "Gör det kortare" eller "Lägg till ett exempel från verkligheten".`,
        refinePlaceholder: `Vad ska AI ändra?`,
        refineButton: `Förfina`,
        refineWhat: `Vad ska förfinas:`,
        refineScript: `Manus`,
        refineStoryboard: `Storyboard`,
        refineBoth: `Båda`,
        changeFormat: `Klicka för att byta format`,
        chooseFormat: `Välj innehållsformat`,
        chooseFormatHelp: `Välj det bästa sättet att leverera det här avsnittet. EduScript föreslår format som passar innehållet — men du kan välja vilket som helst.`,
        recommendedForThisSection: `Rekommenderade för detta avsnitt`,
        recommendedHelp: `Dessa format passar manuset och storyboarden du skrivit. Börja här om du är osäker.`,
        close: `Stäng`,
        searchFormats: `Sök format efter namn eller användning...`,
        clearSearch: `Rensa`,
        noFormatsFound: `Inga format matchar din sökning.`,
        currentLabel: `Valt`,
        bestForLabel: `Bäst för`,
        showContents: `Innehåll`,
        hideContents: `Stäng`,
        resetReviews: `Återställ granskning`,
        exportPdf: `Exportera PDF`,
        exporting: `Exporterar…`,
    },
    phasesLabels: {
        manuscript: `Manus`,
        production: `Produktion`,
        delivery: `Leverans`,
    },
    productionLabels: {
        title: `Produktionstavla`,
        subtitle: `Varje block är en mediapunkt som ska produceras. Ladda upp ditt material, markera som klart och gå vidare. Du kan komma tillbaka när som helst — ditt arbete sparas.`,
        contents: `Innehåll`,
        sectionLabel: `Avsnitt`,
        blocksLabel: `block`,
        blockLabel: `Block`,
        statusPending: `Väntar`,
        statusInProgress: `Pågår`,
        statusApproved: `Godkänt`,
        markPending: `Markera som väntar`,
        markInProgress: `Markera som pågående`,
        markApproved: `Markera som godkänt`,
        uploadAsset: `Ladda upp eget`,
        replaceAsset: `Ersätt`,
        generateWithAi: `Generera med AI`,
        regenerateWithAi: `Generera om med AI`,
        uploading: `Laddar upp...`,
        generating: `Genererar...`,
        generationFailed: `Generering misslyckades`,
        retry: `Försök igen`,
        textOnly: `Endast text — inget material behövs`,
        notes: `Produktionsanteckningar`,
        notesPlaceholder: `Lägg till en anteckning till produktionsteamet...`,
        progressLabel: `Produktionsstatus`,
        approvedCount: `godkända`,
        back: `Tillbaka till Manus`,
        finalize: `Slutför produktion`,
        finalizeSubtext: `När alla block är godkända, gå till Leverans`,
        allBlocksApproved: `Alla block godkända`,
        blocksRemaining: `block kvar att godkänna`,
        noSectionSelected: `Välj ett avsnitt för att se dess block`,
    },
    dashboardLabels: {
        welcome: `Välkommen`,
        subtitle: `Fortsätt där du slutade, eller börja något nytt.`,
        createNew: `Skapa ny kurs`,
        creating: `Skapar...`,
        createFirst: `Skapa din första kurs`,
        inProgress: `Pågående`,
        completed: `Klara`,
        continueAction: `Fortsätt`,
        openAction: `Öppna`,
        allCourses: `Alla kurser`,
        searchPlaceholder: `Sök kurser...`,
        sortNewest: `Nyaste först`,
        sortOldest: `Äldsta först`,
        sortAZ: `A — Ö`,
        sortZA: `Ö — A`,
        courses: `kurser`,
        lessons: `lektioner`,
        untitled: `Namnlös kurs`,
        loadMore: `Ladda fler`,
        subtitleEmpty: `Skapa din första kurs och låt AI hjälpa dig bygga den.`,
        subtitleInProgress: `Du har`,
        emptyTitle: `Inga kurser ännu`,
        emptySubtitle: `Skapa din första kurs och låt AI hjälpa dig bygga den.`,
        noResults: `Inga kurser matchar din sökning.`,
        clearSearch: `Rensa sökning`,
        lastVisited: `Senast besökta`,
        showDetails: `Visa detaljer`,
        createdLabel: `Skapad`,
        lastUpdated: `Senast uppdaterad`,
        ownersLabel: `ägare`,
        justNow: `Just nu`,
        status_draft: `Utkast`,
        status_editing: `Redigeras`,
        status_in_review: `Granskas`,
        status_in_production: `I produktion`,
        status_delivered: `Levererad`,
        manuscript_approved: 'Manuskript godkänt',
    },
    stepsLabels: {
        create: `Skapa`,
        customize: `Anpassa`,
        studio: `Studio`,
    },
    walletLabels: {
        navLabel: `Krediter`,
        title: `Krediter`,
        subtitle: `Ditt AI-kreditsaldo och din aktivitet.`,
        creditsUnit: `krediter`,
        available: `Tillgängligt`,
        reserved: `Reserverat`,
        used: `Använt`,
        totalCredited: `Totalt krediterat`,
        statusHealthy: `Bra`,
        statusWarning: `Snart slut`,
        statusExhausted: `Slut på krediter`,
        warningMessage: `Du har använt {{percent}}% av dina krediter. Begär fler innan de tar slut.`,
        exhaustedMessage: `Du har inga krediter kvar. AI-generering är pausad tills du begär fler.`,
        tabUsage: `Användning`,
        tabTransactions: `Transaktioner`,
        tabRequests: `Kreditförfrågningar`,
        colDate: `Datum`,
        colAction: `Åtgärd`,
        colModel: `Modell`,
        colStatus: `Status`,
        colCredits: `Krediter`,
        colProviderTokens: `Leverantörstokens`,
        colType: `Typ`,
        colDescription: `Beskrivning`,
        colAmount: `Belopp`,
        colBalanceAfter: `Saldo efter`,
        colRequested: `Begärt`,
        colApproved: `Godkänt`,
        colReason: `Anledning`,
        colAdminNote: `Administratörens anteckning`,
        noUsage: `Ingen AI-aktivitet ännu.`,
        noTransactions: `Inga transaktioner ännu.`,
        noRequests: `Du har inte begärt några krediter ännu.`,
        requestTitle: `Begär fler krediter`,
        requestAmount: `Antal krediter`,
        requestReason: `Anledning`,
        requestReasonPlaceholder: `Berätta för administratören vad du behöver krediterna till`,
        submitRequest: `Skicka förfrågan`,
        submitting: `Skickar...`,
        requestSubmitted: `Din kreditförfrågan har skickats.`,
        pendingRequestNotice: `Du har en väntande förfrågan. Du kan skicka en ny när den har granskats.`,
        amountInvalid: `Ange ett heltal som är 1 eller större.`,
        reasonRequired: `En anledning krävs.`,
        reasonTooLong: `Anledningen får inte överstiga 250 tecken.`,
        loadError: `Det gick inte att läsa in dina krediter. Försök igen.`,
        retry: `Försök igen`,
        viewCredits: `Visa krediter`,
        typeInitialCredit: `Startkredit`,
        typeCredit: `Krediter tillagda`,
        typeDebit: `Krediter använda`,
        typeOther: `Justering`,
        aiGeneration: `AI-generering`,
        requestPending: `Väntar`,
        requestApproved: `Godkänd`,
        requestRejected: `Avslagen`,
        requestCancelled: `Avbruten`,
        usageInProgress: `Pågår`,
        usageCompleted: `Slutförd`,
        usageFailed: `Misslyckades`,
        usageProcessing: `Bearbetas`,
        actionCourseCreate: `Kursgenerering`,
        actionCourseUpdate: `Kursrevidering`,
        actionLessonCreate: `Lektionsgenerering`,
        actionLessonUpdate: `Lektionsrevidering`,
        actionChapterCreate: `Kapitelgenerering`,
        actionChapterUpdate: `Kapitelrevidering`,
        actionSectionCreate: `Avsnittsgenerering`,
        actionSectionUpdate: `Avsnittsrevidering`,
        actionScriptCreate: `Manusgenerering`,
        actionScriptUpdate: `Manusrevidering`,
        actionProgramSummarize: `Programsammanfattning`,
        actionRagDocumentIngest: `Dokumentbearbetning`,
    },
    superAdminLabels: {
        consoleTitle: `Superadministratör`,
        consoleSubtitle: `Kredithantering`,
        signInTitle: `Logga in som superadministratör`,
        email: `E-post`,
        password: `Lösenord`,
        signIn: `Logga in`,
        signingIn: `Loggar in...`,
        signInFailed: `Ogiltig e-post eller ogiltigt lösenord.`,
        emailRequired: `Ange en giltig e-postadress.`,
        passwordRequired: `Lösenord krävs.`,
        signOut: `Logga ut`,
        loadError: `Det gick inte att läsa in uppgifterna. Försök igen.`,
        retry: `Försök igen`,
        tabRequests: `Kreditförfrågningar`,
        tabWallet: `Användarens plånbok`,
        tabUsage: `Användning`,
        tabPolicy: `Policy`,
        tabReconciliation: `Avstämning`,
        colUser: `Användar-ID`,
        colActions: `Åtgärder`,
        statusFilter: `Status`,
        statusAll: `Alla`,
        approve: `Godkänn`,
        reject: `Avslå`,
        viewWallet: `Visa plånbok`,
        approveTitle: `Godkänn kreditförfrågan`,
        rejectTitle: `Avslå kreditförfrågan`,
        creditsToGrant: `Krediter att bevilja`,
        noteToUser: `Meddelande till användaren`,
        optional: `valfritt`,
        rejectNoteRequired: `Ett meddelande som förklarar avslaget krävs.`,
        noteTooLong: `Meddelandet får inte överstiga 250 tecken.`,
        confirm: `Bekräfta`,
        cancel: `Avbryt`,
        userId: `Användar-ID`,
        lookUp: `Sök`,
        userIdOrEmail: `Användar-ID eller e-post`,
        userLookupInvalid: `Ange ett användar-ID (1 eller större) eller en del av en e-postadress (högst 255 tecken).`,
        noUserMatch: `Ingen aktiv användare har en e-postadress som innehåller den texten.`,
        selectUser: `Flera användare matchar. Välj en:`,
        userIdInvalid: `Ange ett användar-ID (ett heltal som är 1 eller större).`,
        userFilterInvalid: `Ange ett användar-ID (1 eller större) eller en del av en e-postadress (högst 255 tecken).`,
        adjustTitle: `Justera krediter`,
        addCredits: `Lägg till krediter`,
        removeCredits: `Ta bort krediter`,
        amount: `Krediter`,
        reason: `Anledning`,
        reasonRequired: `En anledning krävs.`,
        amountInvalid: `Ange ett heltal som är 1 eller större.`,
        apply: `Verkställ`,
        applying: `Verkställer...`,
        confirmRemoveTitle: `Ta bort krediter?`,
        confirmRemoveMessage: `Ta bort {{amount}} krediter från användare {{userId}}? Detta registreras permanent i huvudboken och kan bara kvittas med en ny justering.`,
        filterByUser: `Filtrera på användar-ID eller e-post`,
        applyFilter: `Använd`,
        clearFilter: `Rensa`,
        warningThreshold: `Varning för lågt saldo vid (% av använda krediter)`,
        thresholdInvalid: `Ange ett heltal från 1 till 100.`,
        initialCredits: `Startkrediter för nya användare`,
        initialCreditsHint: `Tilldelas en gång när en användare skapas. 1 kredit = 1 leverantörstoken.`,
        initialCreditsInvalid: `Ange ett heltal från 1 till 1000000000.`,
        actionEstimatesTitle: `Krediter som reserveras per AI-åtgärd (uppskattning)`,
        actionEstimatesHint: `Reserveras före varje generering; genereringen blockeras om saldot är lägre. Därefter debiteras de leverantörstoken som faktiskt användes (1 kredit = 1 token) och oanvända krediter återförs. Programsammanfattningar och bearbetning av kunskapsbanken blockeras aldrig; deras uppskattning debiteras bara om ingen användning rapporteras.`,
        estimateInvalid: `Ange ett heltal från 1 till 1000000.`,
        save: `Spara`,
        saving: `Sparar...`,
        runCheck: `Kör kontroll`,
        running: `Kontrollerar...`,
        reconciliationIntro: `Skrivskyddad kontroll av att varje plånbok stämmer med huvudboken. Rättelser görs med kreditjusteringar, aldrig genom att ändra data.`,
        releaseHold: `Släpp`,
        releaseAllHolds: `Släpp alla utgångna reservationer`,
        releasing: `Släpper...`,
        confirmReleaseTitle: `Släpp utgången reservation?`,
        confirmReleaseMessage: `Återför {{amount}} reserverade krediter till användare {{userId}}? Genereringen gick ut utan att slutföras, så den markeras som misslyckad och debiteras inte.`,
        confirmReleaseAllMessage: `Släpp {{count}} utgångna reservationer och återför krediterna till användarna? Genereringarna gick ut utan att slutföras, så de markeras som misslyckade och debiteras inte.`,
        clean: `Rent: varje plånbok stämmer med huvudboken.`,
        notClean: `Avvikelser hittades. Undersök innan du rättar med en justering.`,
        checkedAt: `Kontrollerad`,
        errorsTitle: `Fel`,
        warningsTitle: `Varningar`,
        rowsShown: `Visar högst {{limit}} rader per kontroll.`,
        noRows: `Inga`,
        check_wallet_mismatches: `Plånboken stämmer inte med huvudboken`,
        check_charged_mismatch: `Debitering stämmer inte med huvudboken`,
        check_uncovered_usage: `Användning som inte debiterats (saldot nådde 0)`,
        check_debit_without_completed_request: `Debitering utan slutförd generering`,
        check_unexpected_ledger_types: `Oväntade typer av huvudboksposter`,
        check_stale_reservations: `Utgångna reservationer som fortfarande är aktiva`,
        check_stuck_requests: `Genereringar som fastnat`,
    },
} as const;
